// extracted by mini-css-extract-plugin
export var arrow = "_3t-6";
export var changeItem = "_3t-3";
export var changesHeader = "_3t-1";
export var changesList = "_3t-2";
export var container = "_3t-0";
export var pathLabel = "_3t-4";
export var value = "_3t-7";
export var valuesContainer = "_3t-5";